import { FC } from 'react';
import InjuredAthletesSection from '../../InjuredAthletesSection';
import { ChartEmptyState } from '../../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import { ITeamTimelineMetric } from '../../../../models/injury';
import { InjuredAthleteSummary } from '../../../types';
import { INJURY_SEVERITY } from '../../../../enums/injuries';

// Riceve gli infortuni ACTIVE già filtrati dai dati timeline (hanno firstName/lastName)
type ActiveEntry = ITeamTimelineMetric['data'][number];

interface Props {
  data: ActiveEntry[] | null;
}

/**
 * Riusa `InjuredAthletesSection` (stessa card "Infortunati" della tab Readiness)
 * per lista + link al profilo atleta, invece di una lista ad-hoc duplicata.
 * Il metric `timeline` non porta `severity`/`rtpPhase` per singolo infortunio:
 * la severità viene marcata "da valutare" (mai inventata) e `daysOut` usa
 * `daysLost` (nullable qui) con fallback a 0.
 */
export const TeamCurrentlyInjuredCard: FC<Props> = ({ data }) => {
  if (!data?.length) return <ChartEmptyState />;

  const injured: InjuredAthleteSummary[] = data.map((inj) => ({
    injuryId: inj.injuryId,
    athleteId: inj.athleteId,
    firstName: inj.firstName,
    lastName: inj.lastName,
    bodyZone: inj.bodyZone,
    daysOut: inj.daysLost ?? 0,
    severity: INJURY_SEVERITY.DA_VALUTARE,
  }));

  return <InjuredAthletesSection injured={injured} />;
};
